import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=ae86006a&scoped=true&"
import script from "./DocumentationView.vue?vue&type=script&lang=js&"
export * from "./DocumentationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae86006a",
  null
  
)

export default component.exports